module.exports = __webpack_public_path__ + "img/Path 2@3x.515733fb.png";